var _defs, _rect, _rect2, _rect3, _text, _text2, _circle, _circle2, _circle3, _circle4, _path, _path2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNamePlates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "np-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "np-plate",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B84450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#67141D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "np-gold-txt",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5E8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C9A227"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#np-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 320,
    fill: "#EFDFC0",
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 110,
    width: 240,
    height: 100,
    rx: 6,
    fill: "url(#np-plate)",
    stroke: "#DDB65C",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 155,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "url(#np-gold-txt)",
    letterSpacing: 3
  }, "THE SHARMA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 185,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 15,
    fill: "#EAD08D",
    letterSpacing: 6
  }, "R E S I D E N C E")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 125,
    r: 4,
    fill: "#EAD08D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 125,
    r: 4,
    fill: "#EAD08D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 195,
    r: 4,
    fill: "#EAD08D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 195,
    r: 4,
    fill: "#EAD08D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 110 q-20 -10 -10 -30 q20 5 10 30",
    fill: "#8C6C1A",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 210 q20 10 10 30 q-20 -5 -10 -30",
    fill: "#8C6C1A",
    opacity: 0.7
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 270,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Custom Name Plates")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamePlates);
export default __webpack_public_path__ + "static/media/name-plates.8c4a6675399e7c7f70a662e4ac8c87a7.svg";
export { ForwardRef as ReactComponent };